module.exports = __webpack_public_path__ + "static/heroes-bg-map-mobilesize-57b8762bb5db182bcd7bc79eaa577c6d.gif";